import ReuseableTable from "components/Tables/ReuseableTable";
import React from "react";
import { Button, Modal, ModalBody, Table } from "reactstrap";

const BrandAmbassadorWinnerModal = ({
  winnerModal,
  toggleWinnerModal,
  winnerData,
}) => {
  const columns = [
    "Athlete Name",
    "Athlete Email",
    "Total Votes",
    "Winning price",
  ];

  const keyMap = {
    "Athlete Name": "athleteName",
    "Athlete Email": "athleteEmail",
    "Total Votes": "totalVotes",
    "Winning Price": "winningPrice",
  };
  return (
    <Modal isOpen={winnerModal} toggle={toggleWinnerModal} size="lg" centered>
      <h1 className="text-center mt-1 mb-0 p-2 pb-0"> winner Detail</h1>
      <ModalBody>
        <ReuseableTable
          columns={columns}
          data={[
            {
              athleteName: winnerData?.leaderBoard?.athleteName || "N/A",
              athleteEmail: winnerData?.leaderBoard?.athleteEmail || "N/A",
              totalVotes: winnerData?.WinningVotes
                ? `${winnerData.WinningVotes}$`
                : "N/A",
              winningPrice: winnerData?.winnerAmount
                ? `${winnerData.winnerAmount}$`
                : "N/A",
            },
          ]}
          keyMap={keyMap}
        />

        <div className="text-right mt-2">
          <Button color="danger" size="sm" onClick={toggleWinnerModal}>
            Close
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default BrandAmbassadorWinnerModal;
